var _process$env;

import LegacyAnalyticsContext from './LegacyAnalyticsContext';
import ModernAnalyticsContext from './ModernAnalyticsContext';
var ExportedAnalyticsContext;

if (typeof process !== 'undefined' && process !== null && (_process$env = process.env) !== null && _process$env !== void 0 && _process$env['ANALYTICS_NEXT_MODERN_CONTEXT']) {
  ExportedAnalyticsContext = ModernAnalyticsContext;
} else {
  ExportedAnalyticsContext = LegacyAnalyticsContext;
}

export default ExportedAnalyticsContext;